<template>
  <div class="py-5 mx-4">
    <a @click="newChallenge" type="button" class="mt-5 d-flex align-items-center justify-content-center btn bg-orange-lighter flex-fill rounded-button">
      Criar novo jogo
    </a>
  </div>
</template>

<script>
import alexa from '@/utils/alexa';
export default {
  methods: {
    newChallenge() {
      alexa.callIntent('newChallenge');
    }
  }
};
</script>
